import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import SettingsFormContainer, {
  SettingsFormHeader,
} from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";
import { Alert, AlertDescription } from "@babackapp/ui/components/alert";
import { Info } from "lucide-react";
import { Link, Navigate } from "react-router-dom";
import { ArchivedDisapprovalReasonList } from "./components/archived-disapproval-reason-list";
import { DisapprovalReasonList } from "./components/disapproval-reason-list";
import { useHasDisapprovalWorkflow } from "./hooks/use-has-disapproval-workflow";

export default function DisapprovalReasonsPage() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const hasWorkflow = useHasDisapprovalWorkflow(shop.id);

  // The sidebar entry is already gated on the toggle; this covers the merchant
  // who kept the URL, or turned the capture back off from another tab.
  if (!shop.preferences.notifications.askDisapprovalReason) {
    return (
      <Navigate
        to={`/shops/${shop.id}/settings/notifications/configuration`}
        replace
      />
    );
  }

  return (
    <SettingsFormContainer>
      <SettingsFormHeader
        title={t("settings.disapprovalReasons.title")}
        description={t("settings.disapprovalReasons.subtitle")}
      />

      {/* Capture and sending are two different switches: without a workflow the
          reason stops at the return's activity feed, and the screen has to say
          so rather than let the merchant assume an email goes out. */}
      {!hasWorkflow && (
        <Alert>
          <Info className="size-4" />
          <AlertDescription>
            {t("settings.disapprovalReasons.noWorkflow")}{" "}
            <Link
              to={`/shops/${shop.id}/settings/notifications/workflows`}
              className="underline"
            >
              {t("settings.disapprovalReasons.noWorkflowLink")}
            </Link>
          </AlertDescription>
        </Alert>
      )}

      <DisapprovalReasonList />
      <ArchivedDisapprovalReasonList />
    </SettingsFormContainer>
  );
}
